
import { useState } from "react";
import { Loader2 } from "lucide-react";
import { FormControl, FormDescription, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ElevenLabsAgent } from "@/types/admin";

interface AgentSelectorProps {
  agentSource: "local" | "elevenlabs";
  field: any;
  isLoadingElevenLabsAgents: boolean;
  isLoadingLocalAgents: boolean;
  elevenLabsAgents: ElevenLabsAgent[];
  localAgents: any[] | undefined;
}

const AgentSelector = ({
  agentSource,
  field,
  isLoadingElevenLabsAgents,
  isLoadingLocalAgents,
  elevenLabsAgents,
  localAgents,
}: AgentSelectorProps) => {
  const isLoading = agentSource === "elevenlabs" ? isLoadingElevenLabsAgents : isLoadingLocalAgents;
  const agents = agentSource === "elevenlabs" ? elevenLabsAgents : localAgents || [];

  return (
    <FormItem>
      <FormLabel>Select Agent</FormLabel>
      <Select
        onValueChange={field.onChange}
        defaultValue={field.value}
        disabled={isLoading}
      >
        <FormControl>
          <SelectTrigger>
            <SelectValue placeholder={`Select an ${agentSource === "elevenlabs" ? "ElevenLabs" : "local"} agent`} />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          {isLoading ? (
            <div className="flex items-center justify-center p-2">
              <Loader2 className="h-4 w-4 animate-spin" />
            </div>
          ) : agents.length > 0 ? (
            agentSource === "elevenlabs" ? (
              // ElevenLabs agents
              elevenLabsAgents.map((agent: ElevenLabsAgent) => (
                <SelectItem key={agent.agent_id} value={agent.agent_id}>
                  {agent.name}
                </SelectItem>
              ))
            ) : (
              // Local agents
              localAgents?.map((agent) => (
                <SelectItem key={agent.id} value={agent.id}>
                  {agent.name}
                </SelectItem>
              ))
            )
          ) : (
            <SelectItem value="no-agents" disabled>
              No {agentSource === "elevenlabs" ? "ElevenLabs" : "local"} agents available
            </SelectItem>
          )}
        </SelectContent>
      </Select>
      <FormDescription>
        {agentSource === "elevenlabs" 
          ? "Select an agent directly from your ElevenLabs account" 
          : "Select an agent from your local database"}
      </FormDescription>
      <FormMessage />
    </FormItem>
  );
};

export default AgentSelector;
